<template>
  <section class="section stats auto">
    <div class="inner-content">
      <h4 class="ta-l">{{ $t('about.stats.title') }}</h4>
      <div class="space h100"></div>
      <div class="stats-grid">
        <div
          v-for="(cfg, i) in statConfig"
          :key="cfg.id"
          class="stat-item"
          :style="{ animationDelay: `${i * 0.18}s` }"
        >
          <div class="circle-wrap">
            <svg class="circle-svg" viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg">
              <circle class="track" cx="80" cy="80" r="68" />
              <circle
                class="progress"
                cx="80"
                cy="80"
                r="68"
                :stroke="cfg.color"
                :style="{
                strokeDasharray: circumference,
                strokeDashoffset: animated ? circumference * (1 - cfg.pct) : circumference,
                transitionDelay: `${i * 0.18 + 0.3}s`
              }"
              />
            </svg>

            <div class="circle-inner">
            <span class="circle-value">
              <span class="count" :data-target="cfg.numericValue" :ref="el => countRefs[i] = el">
                {{ cfg.displayValue }}
              </span>
              <span class="circle-unit">{{ $tm('about.stats.items')[i].unit }}</span>
            </span>
              <span class="circle-label">{{ $tm('about.stats.items')[i].label }}</span>
              <div v-if="cfg.badgeStyles" class="badge-wrap">
              <span
                v-for="(style, j) in cfg.badgeStyles"
                :key="j"
                class="badge"
                :style="{ background: style.bg, color: style.color }"
              >
                {{ $tm('about.stats.items')[i].badges[j] }}
              </span>
              </div>
            </div>
          </div>

          <p class="stat-desc">{{ $tm('about.stats.items')[i].desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const radius = 68
const circumference = 2 * Math.PI * radius

const animated = ref(false)

const statConfig = [
  {
    id: 'projects',
    displayValue: '30',
    numericValue: 30,
    pct: 0.75,
    color: '#4F6EF7'
  },
  {
    id: 'clients',
    displayValue: '',
    numericValue: null,
    pct: 0.6,
    color: '#2EC4A9',
    badgeStyles: [
      { bg: '#E8F0FE', color: '#1A4FC4' },
      { bg: '#E6F9F5', color: '#0D7A63' }
    ]
  },
  {
    id: 'retention',
    displayValue: '91',
    numericValue: 91,
    pct: 0.91,
    color: '#F4845F'
  },
  {
    id: 'years',
    displayValue: '9',
    numericValue: 9,
    pct: 0.9,
    color: '#A78BFA'
  }
]

const countRefs = []

function animateCount (el, target, duration = 1400) {
  if (!el || target === null) return
  const start = performance.now()
  const update = (now) => {
    const elapsed = now - start
    const progress = Math.min(elapsed / duration, 1)
    const eased = 1 - Math.pow(1 - progress, 3)
    el.textContent = Math.round(eased * target)
    if (progress < 1) requestAnimationFrame(update)
  }
  requestAnimationFrame(update)
}

onMounted(() => {
  requestAnimationFrame(() => {
    setTimeout(() => {
      animated.value = true
      statConfig.forEach((cfg, i) => {
        if (cfg.numericValue !== null) {
          setTimeout(() => {
            animateCount(countRefs[i], cfg.numericValue, 1400)
          }, i * 180 + 300)
        }
      })
    }, 100)
  })
})
</script>
